import type { components } from "@/services/customer-schema";
import { faker } from "@faker-js/faker";

faker.seed(0);

const numAccounts = 4;

const balances = [...Array(numAccounts)].map(() => ({
  pendingDeposit: faker.finance.amount({ min: 10000, max: 20000 }),
  pendingWithdrawal: faker.finance.amount({ min: 1000, max: 5000 }),
  available: faker.finance.amount({ min: 100000, max: 500000 }),
  currencyCode: "USD",
}));

export const globalTotal = balances
  .reduce((sum, item) => sum + parseFloat(item.available), 0)
  .toString();

export const globalPendingDeposits = balances
  .reduce((sum, item) => sum + parseFloat(item.pendingDeposit), 0)
  .toString();

export const globalPendingWithdrawals = balances
  .reduce((sum, item) => sum + parseFloat(item.pendingWithdrawal), 0)
  .toString();

export const accountBases = [...Array(numAccounts)].map(() => ({
  id: faker.string.numeric(6),
  name: faker.company.name(),
}));

export const accounts: components["schemas"]["Accounts"] = {
  accounts: [
    {
      type: "AGGREGATED",
      ...accountBases[0],
      id: "12345",
      name: "Deanna Troi",
      total: balances[0],
      assets: [
        {
          id: "Solana",
          name: "SOL",
          blockchain: "SOLANA",
        },
        {
          id: "Bitcoin",
          name: "BTC",
          blockchain: "BITCOIN",
        },
        {
          id: "Ethereum",
          name: "ETH",
          blockchain: "ETHEREUM",
        },
        {
          id: "Chainlink",
          name: "LINK",
          blockchain: "SOLANA",
        },
      ],
    },
    {
      type: "AGGREGATED",
      ...accountBases[1],
      id: "12346",
      name: "Johns Inc",
      total: balances[1],
      assets: [
        {
          id: "Bitcoin",
          name: "BTC",
          blockchain: "BITCOIN",
        },
        {
          id: "Ethereum",
          name: "ETH",
          blockchain: "ETHEREUM",
        },
      ],
    },
    {
      type: "SEGREGATED",
      ...accountBases[2],
      total: balances[2],
      assets: [
        {
          id: "Bitcoin",
          name: "BTC",
          blockchain: "BITCOIN",
        },
      ],
    },
    {
      type: "AGGREGATED",
      ...accountBases[3],
      total: balances[3],
      assets: [
        {
          id: "Ethereum",
          name: "ETH",
          blockchain: "ETHEREUM",
        },
      ],
    },
  ],
  pagination: {
    limit: 10,
    firstCursor: "abc123",
  },
};

export const accountArrayForEachType: components["schemas"]["Account"][] =
  accounts.accounts.map((account, index) => ({
    ...account,
    depositAddressMode: "STANDARD",
    assets: (account.assets ?? []).map((asset) => ({
      ...asset,
      balance: {
        pendingDeposit: {
          amount: 1000000000 + index * 1000, // Example dynamic values
          scale: 9,
          amountString: `${((1000000000 + index * 1000) / 1e9).toFixed(9)}`,
          valuation: {
            amount: (0.5 + index * 0.1).toFixed(2),
            currencyCode: "USD",
          },
        },
        pendingWithdrawal: {
          amount: 500000000 + index * 500, // Example dynamic values
          scale: 9,
          amountString: `${((500000000 + index * 500) / 1e9).toFixed(9)}`,
          valuation: {
            amount: (0.25 + index * 0.05).toFixed(2),
            currencyCode: "USD",
          },
        },
        available: {
          amount: 2000000000 + index * 100000, // Example dynamic values
          scale: 9,
          amountString: `${(2000000000 + index * 10000000) / 1e9}`,
          valuation: {
            amount: (1.0 + index * 0.2).toFixed(2),
            currencyCode: "USD",
          },
        },
      },
    })),
  }));

export const accountExample: components["schemas"]["Account"] =
  accountArrayForEachType[0];
